export const dataUrlToBlob = (dataUrl: string): Blob => {
  const [header, base64] = dataUrl.split(',')
  const contentType =
    header.match(/data:(.*?);base64/)?.[1] ?? 'application/octet-stream'
  const binary = atob(base64)
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
  return new Blob([bytes], { type: contentType })
}
